var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import NukaSwiper from 'nuka-carousel';
import DefaultArrow from './DefaultArrow';
import DefaultDots from './DefaultDots';
import * as ST from './styled';
var DEFAULT_AUTOPLAY_INTERVAL = 3000;
var DOTS_PADDING = -20;
var ARROWS_PADDING = -32;
var getDefaultControlsContainerStyles = function (key) {
    switch (key) {
        case 'BottomCenter':
            return {
                bottom: DOTS_PADDING,
            };
        case 'CenterRight':
            return {
                right: "".concat(ARROWS_PADDING, "px"),
            };
        case 'CenterLeft':
            return {
                left: "".concat(ARROWS_PADDING, "px"),
            };
        default: return;
    }
};
var NukaCarousel = function (_a) {
    var CustomArrow = _a.customArrow, CustomDots = _a.customDots, children = _a.children, withoutArrows = _a.withoutArrows, withoutControls = _a.withoutControls, withoutDots = _a.withoutDots, _b = _a.autoplayInterval, autoplayInterval = _b === void 0 ? DEFAULT_AUTOPLAY_INTERVAL : _b, autoplay = _a.autoplay, className = _a.className, customDotsStyles = _a.customDotsStyles, props = __rest(_a, ["customArrow", "customDots", "children", "withoutArrows", "withoutControls", "withoutDots", "autoplayInterval", "autoplay", "className", "customDotsStyles"]);
    var _c = useState(false), pausedAutoplay = _c[0], setPausedAutoplay = _c[1];
    var Arrow = CustomArrow || DefaultArrow;
    var Dots = CustomDots || DefaultDots;
    var swiperRef = useRef();
    useEffect(function () {
        var _a;
        (_a = swiperRef === null || swiperRef === void 0 ? void 0 : swiperRef.current) === null || _a === void 0 ? void 0 : _a.setDimensions();
    }, [withoutArrows, withoutControls]);
    var handleMouseOver = function () {
        if (autoplay) {
            setPausedAutoplay(true);
        }
    };
    var handleMouseOut = function () {
        if (autoplay) {
            setPausedAutoplay(false);
        }
    };
    return (<ST.Container withoutDots={withoutDots || withoutControls} withoutArrows={withoutArrows || withoutControls} onTouchStart={handleMouseOver} onTouchEnd={handleMouseOut} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} className={className}>
            <NukaSwiper ref={swiperRef} 
    // @ts-ignore
    getControlsContainerStyles={getDefaultControlsContainerStyles} renderCenterLeftControls={function (_a) {
        var previousSlide = _a.previousSlide;
        return withoutArrows || <Arrow previousSlide={previousSlide}/>;
    }} renderCenterRightControls={function (_a) {
        var nextSlide = _a.nextSlide;
        return withoutArrows || <Arrow nextSlide={nextSlide}/>;
    }} renderBottomCenterControls={function (props) { return withoutDots || (<Dots {...props} autoplayInterval={autoplayInterval} autoplay={!!(autoplay && !pausedAutoplay)} customDotsStyles={customDotsStyles}/>); }} autoplayInterval={autoplayInterval} autoplay={autoplay} withoutControls={withoutControls} {...props}>
                {children}
            </NukaSwiper>
        </ST.Container>);
};
export default NukaCarousel;
